import * as React from 'react';
/**
 *
 * Original name: upload file
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3704%3A546
 *
 */
export const UploadFileSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { d: "M92.192 26.95 82.05 16.808A12.917 12.917 0 0 0 72.858 13H24v94h72V36.143a12.912 12.912 0 0 0-3.808-9.193ZM86.758 30H79v-7.758L86.758 30ZM90 101H30V19h42.858c.048 0 .094.006.142.007V36h16.993c0 .048.007.095.007.143V101Z", fill: "currentColor" }),
    React.createElement("path", { d: "M63 48h-6c-2.568 6.745-11.257 11.274-11.342 11.317l2.684 5.366A38.928 38.928 0 0 0 57 58.443V82h6V58.443a38.927 38.927 0 0 0 8.658 6.241l2.687-5.364C74.257 59.274 65.568 54.745 63 48Z", fill: "currentColor" })));
